import { useState, useCallback } from 'react';
import { analyticAccountingApi } from '../services/api/endpoints/analyticAccounting';
import type { AnalyticReportFilter, AnalyticReportData } from '../types/analytic-accounting';

export function useAnalyticReport() {
  const [reportData, setReportData] = useState<AnalyticReportData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadReport = useCallback(async (filters: AnalyticReportFilter) => {
    try {
      setLoading(true);
      setError(null);

      const response = await analyticAccountingApi.getReport(filters);
      if (response && 'data' in response) {
        const data = (response.data as any)?.data || response.data;
        setReportData(data as AnalyticReportData);
      }
    } catch (err: any) {
      setError(err.message || 'Erreur lors du chargement du rapport analytique');
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    reportData,
    loading,
    error,
    loadReport,
  };
}
